export default "/public/dist/resources/EstrattoAccredia.pdf";